/// <reference types="webpack-env" />
const context = require.context("../../../", true, /\.svg$/);
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const allSvgs: Record<string, string> = Object.fromEntries(context.keys().map((key: string) => [key, context(key) as string]));
